import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IRepasseSetorialPagedResponse } from "models/response/repasse-setorial-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type RepassesSetoriaisTableProps = {
    currentItems: PaginationResponse<IRepasseSetorialPagedResponse>;
};

export const RepassesSetoriaisTable: React.FC<RepassesSetoriaisTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum repasse setorial encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Área</TableCell>
                        <TableCell>Origem</TableCell>
                        <TableCell>Exercício</TableCell>
                        <TableCell align="right">V. Previsto</TableCell>
                        <TableCell align="right">V. Realizado</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <Chip label={item.areaName} size="small" style={getCategoryColor(item.areaName)} />
                            </TableCell>
                            <TableCell>{item.origemName}</TableCell>
                            <TableCell>{item.ano}</TableCell>
                            <TableCell align="right">
                                {item.valorPrevisto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="right">
                                {item.valorRealizado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/repasses-setoriais/${item.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
